import React, { forwardRef, useEffect, useState } from "react";
import { CloseOutlined } from "@phonepe/enigma-ui-icons";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { StyledChip, StyledSuffixContainer } from "./chip.styles";
import { ChipProps } from "./chip.types";

export const Chip = forwardRef<HTMLButtonElement, ChipProps>(
    (
        {
            selected: selectedExternal = false,
            selectableWhenSuffix = false,
            children,
            prefix,
            suffix,
            onClick,
            onSuffixClick,
            disabled,
            ...rest
        },
        ref
    ) => {
        const [selected, setSelected] = useState(selectedExternal);
        const token = useEnigmaToken();
        const showDefaultSuffix = typeof suffix === "boolean";

        useEffect(() => {
            setSelected(selectedExternal);
        }, [selectedExternal]);

        const handleChipClick = (e: React.MouseEvent<HTMLButtonElement>) => {
            const isSelectable = !suffix || selectableWhenSuffix;
            if (isSelectable) {
                setSelected(!selected);
                onClick?.(e, !selected);
            } else {
                onClick?.(e);
            }
        };

        return (
            <StyledChip
                token={token}
                onClick={handleChipClick}
                selected={(!suffix || selectableWhenSuffix) && selected}
                hasPrefix={Boolean(prefix)}
                hasSuffix={Boolean(suffix)}
                hasOnClick={Boolean(onClick)}
                disabled={disabled}
                ref={ref}
                {...rest}
            >
                {prefix}
                {children}
                {suffix && (
                    <StyledSuffixContainer
                        onClick={(e) => {
                            e.stopPropagation();
                            onSuffixClick?.(e);
                        }}
                        disabled={disabled}
                    >
                        {showDefaultSuffix ? (
                            <CloseOutlined size="small" />
                        ) : (
                            suffix
                        )}
                    </StyledSuffixContainer>
                )}
            </StyledChip>
        );
    }
);

Chip.displayName = "Chip";
